import type { FaireProductEntity } from "../../entity_types/product";

export const p_ft4nxutj5a: FaireProductEntity = {
  token: "p_ft4nxutj5a",
  type: "product",
  name: "Cast Iron Garden Fairy Statue Mystical Decor",
  brandName: "Iron & Blossom",
  imageUrl:
    "https://cdn.faire.com/fastly/abfee3a72d2dcab80769584054cbf2ad46593505423fc6e57dbf4531216f9520.png",
  priceDollars: 4,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/df2bb9a3d6d724ed0d5b18a0513de3c54099c07a1ed3104c37d3acee0f045b37.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
